export enum OrderDocumentType {
  OrderConfirmation = 'order_confirmation',
  PackingSlip = 'packing_slip',
  Invoice = 'invoice',
  CreditNote = 'credit_note',
}
